import { z } from "zod";

/**
 * Provider schema
 * Validates a single provider entry
 */
export const providerSchema = z.object({
  providerName: z.string().min(1, "Provider name is required"),
  credentials: z.string(),
  practicingCity: z.string().min(1, "Practicing city is required"),
  careStartDate: z.coerce.date().max(new Date(), "Care start date must be in the past"),
  careEndDate: z.coerce.date().max(new Date(), "Care end date must be in the past").nullable(),
});

/**
 * Provider History validation schema
 * Validates the entire provider history category
 */
export const providerHistoryValidation = z.object({
  primaryCareProvider: providerSchema,
  hasReferringProvider: z.boolean(),
  isSameAsPrimaryCare: z.boolean().nullable(),
  referringProvider: providerSchema.nullable(),
});

export type Provider = z.infer<typeof providerSchema>;

export default providerHistoryValidation;
